/* 상품 카드 이미지 위 카트 버튼: 바로 담고 오른쪽 장바구니 열기 */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.nc-card-action--cart');
  if (!btn || btn.disabled) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;
  if (!variantId) {
    location.href = btn.dataset.url;
    return;
  }

  const drawer = document.querySelector('cart-drawer');
  const body = new FormData();
  body.append('id', variantId);
  body.append('quantity', 1);
  if (drawer) {
    body.append('sections', drawer.getSectionsToRender().map((s) => s.id));
    body.append('sections_url', location.pathname);
  }

  btn.disabled = true;
  try {
    const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}`, {
      method: 'POST',
      body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
    });
    const data = await res.json();

    if (data.status) {
      alert(data.description || data.message || '장바구니에 담지 못했습니다.');
      return;
    }

    if (!drawer) {
      location.href = window.routes?.cart_url || '/cart';
      return;
    }

    drawer.classList.remove('is-empty');
    drawer.renderContents(data);
    if (window.publish && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nc-card-actions', productVariantId: variantId, cartData: data });
    }
  } catch (err) {
    console.error(err);
    location.href = btn.dataset.url;
  } finally {
    btn.disabled = false;
  }
});
